import { FileUploadOutlined } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { memo, useRef } from 'react';
import { toast } from 'react-toastify';

const GeoTargetingZipCodesUpload = memo(({ onUpload }) => {
  const fileInputRef = useRef();

  const handleUpload = ({ target: { files } }) => {
    const [file] = files;

    if (file) {
      const reader = new FileReader();

      reader.onload = ({ target: { result: fileContent } }) => {
        // Convert CSV to array
        const rows = fileContent.split(/\s/).filter(Boolean);

        onUpload(rows);
        toast.success(`Uploaded ${file.name}`);
        fileInputRef.current.value = null;
      };

      reader.onerror = error => {
        console.error('Error reading CSV file:', error);
        toast.error(`Failed to upload ${file.name}\nPlease try again`);
        fileInputRef.current.value = null;
      };

      // Read the file as text
      reader.readAsText(file);
    }
  };

  return (
    <div className='flex items-center gap-3 print:hidden'>
      <label>
        <input ref={fileInputRef} hidden type='file' accept='.csv' onChange={handleUpload} />
        <span className='flex items-center justify-center cursor-pointer gap-2 w-[150px] h-[36px] rounded bg-[#1b433226] hover:bg-[#1b43328d]'>
          <FileUploadOutlined />
          Upload CSV
        </span>
      </label>
      <p className='text-[12px] text-[#84818A]'>For included zip codes only</p>
    </div>
  );
});

GeoTargetingZipCodesUpload.propTypes = {
  onUpload: PropTypes.func,
};

export default GeoTargetingZipCodesUpload;
